import { SagaIterator } from 'redux-saga'
import { fork, put, takeEvery, call } from 'redux-saga/effects'
import { DataAction } from '../../actions/commons'
import {
  BILLING_GUIDE_FETCH_CLINICS,
  fetchClinicsSuccess,
  fetchClinicsFail,
} from '../../actions/BillingGuideActions/billingGuideActions'
import { get, ResponseStatus, ResponseWithStatus } from '../../fetch'
import { SuggestResponse } from '../../domain/models/rest/SearchResponse'
import text from '../../_constants/text'

const ELASTIC_URL = process.env.REACT_APP_IMED_WEBSITE_ELASTIC_URL

// Type for the raw API response (the API returns more fields, but we only care about these for now)
type ClinicResponse = {
  name: string
  clinic_name: string
  clinic_name_search?: string
  region: string
}

export function* fetchClinicsSaga(action: DataAction<{ lat: string; lon: string }>): SagaIterator {
  try {
    const params = {
      index: 'clinic',
      mode: 'clinics',
      lat: action.data.lat,
      lon: action.data.lon,
    }

    const response = (yield call(get<SuggestResponse<ClinicResponse>>, ELASTIC_URL, {}, params)) as ResponseWithStatus<
      SuggestResponse<ClinicResponse>
    >

    if (response.status !== ResponseStatus.SUCCESS) {
      console.warn('API error while fetching billing guide clinics:', response.status)
      yield put(fetchClinicsFail(text.BILLING_GUIDE_CLINIC_ERROR_MESSAGE))
      return
    }

    const data: SuggestResponse<ClinicResponse> = response.data

    // Filter out Comrad RIL & AMI (Inner West Sydney) clinics via region name (as pricing data is not yet available for Comrad clinics)
    const filteredClinics =
      data.hits?.hits?.filter((hit) => hit._source.region !== 'Inner West' && !hit._source.region.startsWith('RIL ')) ||
      []

    // Extract clinic name from Elasticsearch response
    const clinics = filteredClinics.map((hit) => hit._source.clinic_name_search || hit._source.clinic_name) || []

    yield put(fetchClinicsSuccess(clinics))
  } catch (error) {
    console.error('Unexpected error while fetching billing guide clinics:', error)
    yield put(fetchClinicsFail(text.BILLING_GUIDE_CLINIC_ERROR_MESSAGE))
  }
}

function* watchFetchClinics(): SagaIterator {
  yield takeEvery(BILLING_GUIDE_FETCH_CLINICS, fetchClinicsSaga)
}

const clinicSaga = [fork(watchFetchClinics)]

export default clinicSaga
